<template>
  <div>
        
  </div>
</template>
<script>
import { mapActions } from 'vuex';

const accountModule = 'accountModule'

export default {
  data() {
    return {

    }
  },

  methods: {
    ...mapActions(accountModule, [
      'requestNaverConnect',
    ]),

    async setRedirectData() {
      const code = this.$route.query.code;
      if (await this.requestNaverConnect(code)) {
        alert('연결이 완료 됐습니다')
        this.$router.push({ name: 'home' })
      } else alert('문제 발생')
    }
  },

  mounted() {
    this.setRedirectData()
  }
}
</script>
<style lang="">
    
</style>